import { clearWidgetCache } from './components/Widgets';
import { clearLibraryCache } from './meta';

/**
 * Live bibliotheek: de server meldt wanneer Plex iets heeft toegevoegd of verwijderd.
 * Dan worden de rijen op Home (en andere schermen die luisteren) stil ververst.
 */

export const LIBRARY_CHANGED = 'tumedia:library-changed';

let es: EventSource | null = null;

export function startLibraryEvents(): () => void {
  if (es) return () => undefined;
  es = new EventSource('/api/events/library');
  es.addEventListener('library', (e) => {
    const d = JSON.parse((e as MessageEvent).data) as { sections: string[] };
    clearWidgetCache();
    clearLibraryCache();
    window.dispatchEvent(new CustomEvent(LIBRARY_CHANGED, { detail: d }));
  });
  return () => {
    es?.close();
    es = null;
  };
}
